<!-- <p>payments works!</p> -->
<!-- <div>
    <form   target="_top" #txnForm [formGroup]="tranxnForm" method="POST" action={{isgPay_url}}  >
      <input type="hidden" [value]="EncDataField"  name="EncData" formControlName="EncData">
      <input type="hidden" [value]="MerchantIdField" name="MerchantId" formControlName="MerchantId">
      <input type="hidden" [value]="BankIdField" name="BankId" formControlName="BankId">
      <input type="hidden" [value]="TerminalIdField" name="TerminalId" formControlName="TerminalId">
      <input type="hidden" [value]="VersionField" name="Version" formControlName="Version">
      <input type="hidden" [value]="TransactionId" name="OrderId" formControlName="TransactionId">
    </form>
  </div> -->


  <div>
    <form   target="_top" #procssForm [formGroup]="processStateForm" method="POST" action={{isgPay_url}}  >
      <input type="hidden" [value]="amountField"   name="amount" formControlName="amount">
      <input type="hidden" [value]="useridField"   name="user_id" formControlName="user_id">
      <input type="hidden" [value]="statusField"   name="status" formControlName="status">

      <input type="hidden" [value]="package_id"   name="package_id" formControlName="package_id">
      <input type="hidden" [value]="customer_id"   name="customer_id" formControlName="customer_id">
      <input type="hidden" [value]="coupon_code"   name="coupon_code" formControlName="coupon_code">
      <input type="hidden" [value]="grand_total"   name="grand_total" formControlName="grand_total">
      <input type="hidden" [value]="order_via"   name="order_via" formControlName="order_via">
      <input type="hidden" [value]="payment_status"   name="payment_status" formControlName="payment_status">
      <input type="hidden" [value]="plan_for"   name="plan_for" formControlName="plan_for">
      <input type="hidden" [value]="plan_id"   name="plan_id" formControlName="plan_id">
      <input type="hidden" [value]="type"   name="type" formControlName="type">
      <input type="hidden" [value]="course_id"   name="course_id" formControlName="course_id">
      <input type="hidden" [value]="subscription_id"   name="subscription_id" formControlName="subscription_id">
      <input type="hidden" [value]="order_id"   name="order_id" formControlName="order_id">
      
    </form>
  </div>